import { isNil, negate } from 'lodash-es'

import { VehicleInputValueVRN } from '../../inputs'
import { ValidationFunctions } from '../types'

export const vehicleTabsVRN: ValidationFunctions = {
  _self: {
    required: () => (value: VehicleInputValueVRN | null | undefined) =>
      !isNil(value?.specification) && !isNil(value.regLookup),
    vrn: (isRequired: boolean) => (value: VehicleInputValueVRN | null | undefined) =>
      !isRequired || negate(isNil)(value?.vrn),
  },
}
